import React from 'react';
import { api } from '../../services/api';
import { useQuery } from '@tanstack/react-query'

function useGetMatchData(matchId) {
  return useQuery({
    queryKey: ['singleMatch', matchId],
    queryFn: async () => {
      const response = await api.fetchSingleMatch(matchId);
      return response;
    },
    enabled: !!matchId,
    staleTime: 2 * 60 * 1000, // 2 minutes
  });
}

export function useSingleMatchData(matchId) {
  const query = useGetMatchData(matchId);

  // Combined loading state
  const isLoading = query.isLoading;
  // Combined error state
  const error = query.error;

  // Extracted data
  const data = React.useMemo(() => {
    return query.data ? query.data.match : null;
  }, [query.data]);

  return {
    data,
    isLoading,
    error,
  };
}
